// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Data_Id$Coronate from "./Data_Id.res.js";

function toString(x) {
  switch (x) {
    case "WhiteWon" :
        return "whiteWon";
    case "BlackWon" :
        return "blackWon";
    case "Draw" :
        return "draw";
    case "Aborted" :
        return "aborted";
    case "WhiteAborted" :
        return "whiteAborted";
    case "BlackAborted" :
        return "blackAborted";
    case "NotSet" :
        return "notSet";
    
  }
}

function fromString(x) {
  switch (x) {
    case "aborted" :
        return "Aborted";
    case "blackAborted" :
        return "BlackAborted";
    case "blackWon" :
        return "BlackWon";
    case "draw" :
        return "Draw";
    case "whiteAborted" :
        return "WhiteAborted";
    case "whiteWon" :
        return "WhiteWon";
    default:
      return "NotSet";
  }
}

function decode(json) {
  return fromString(Belt_Option.getExn(Js_json.decodeString(json)));
}

function scoreByeMatch(white, black, byeValue, $$default) {
  var match = Data_Id$Coronate.isDummy(white);
  var match$1 = Data_Id$Coronate.isDummy(black);
  if (match) {
    switch (byeValue) {
      case "Full" :
          return "BlackWon";
      case "Half" :
          return "Draw";
      case "Zero" :
          break;
      
    }
  } else if (!match$1) {
    return $$default;
  }
  if (!match$1) {
    return "WhiteWon";
  }
  switch (byeValue) {
    case "Full" :
        return "WhiteWon";
    case "Half" :
        return "Draw";
    case "Zero" :
        return "BlackWon";
    
  }
}

function reverse(t) {
  switch (t) {
    case "WhiteWon" :
        return "BlackWon";
    case "BlackWon" :
        return "WhiteWon";
    case "WhiteAborted" :
        return "BlackAborted";
    case "BlackAborted" :
        return "WhiteAborted";
    default:
      return t;
  }
}

function isBye(param) {
  if (Data_Id$Coronate.isDummy(param.whiteId)) {
    return true;
  } else {
    return Data_Id$Coronate.isDummy(param.blackId);
  }
}

function decode$1(json) {
  var d = Js_json.decodeObject(json);
  return {
          id: Data_Id$Coronate.decode(Belt_Option.getExn(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "id");
                        })))),
          whiteId: Data_Id$Coronate.decode(Belt_Option.getExn(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "whiteId");
                        })))),
          blackId: Data_Id$Coronate.decode(Belt_Option.getExn(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "blackId");
                        })))),
          whiteNewRating: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "whiteNewRating");
                        })), Js_json.decodeNumber)) | 0,
          blackNewRating: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "blackNewRating");
                        })), Js_json.decodeNumber)) | 0,
          whiteOrigRating: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "whiteOrigRating");
                        })), Js_json.decodeNumber)) | 0,
          blackOrigRating: Belt_Option.getExn(Belt_Option.flatMap(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "blackOrigRating");
                        })), Js_json.decodeNumber)) | 0,
          result: decode(Belt_Option.getExn(Belt_Option.flatMap(d, (function (d) {
                          return Js_dict.get(d, "result");
                        }))))
        };
}

function encode(data) {
  return Js_dict.fromArray([
              [
                "id",
                Data_Id$Coronate.encode(data.id)
              ],
              [
                "whiteId",
                Data_Id$Coronate.encode(data.whiteId)
              ],
              [
                "blackId",
                Data_Id$Coronate.encode(data.blackId)
              ],
              [
                "whiteNewRating",
                data.whiteNewRating
              ],
              [
                "blackNewRating",
                data.blackNewRating
              ],
              [
                "whiteOrigRating",
                data.whiteOrigRating
              ],
              [
                "blackOrigRating",
                data.blackOrigRating
              ],
              [
                "result",
                toString(data.result)
              ]
            ]);
}

function manualPair(white, black, result, byeValue) {
  var tmp;
  tmp = result === "NotSet" ? scoreByeMatch(white.id, black.id, byeValue, "NotSet") : result;
  return {
          id: Data_Id$Coronate.random(),
          whiteId: white.id,
          blackId: black.id,
          whiteNewRating: white.rating,
          blackNewRating: black.rating,
          whiteOrigRating: white.rating,
          blackOrigRating: black.rating,
          result: tmp
        };
}

function swapColors(match) {
  var x = match.result;
  var tmp;
  switch (x) {
    case "WhiteWon" :
        tmp = "BlackWon";
        break;
    case "BlackWon" :
        tmp = "WhiteWon";
        break;
    case "WhiteAborted" :
        tmp = "BlackAborted";
        break;
    case "BlackAborted" :
        tmp = "WhiteAborted";
        break;
    default:
      tmp = x;
  }
  return {
          id: match.id,
          whiteId: match.blackId,
          blackId: match.whiteId,
          whiteNewRating: match.blackNewRating,
          blackNewRating: match.whiteNewRating,
          whiteOrigRating: match.blackOrigRating,
          blackOrigRating: match.whiteOrigRating,
          result: tmp
        };
}

var Result = {
  toString: toString,
  fromString: fromString,
  scoreByeMatch: scoreByeMatch,
  reverse: reverse
};

export {
  Result ,
  isBye ,
  decode$1 as decode,
  encode ,
  manualPair ,
  swapColors ,
}
/* Data_Id-Coronate Not a pure module */
